import React, { useState, useEffect, useMemo } from "react"
import axios from "axios"
// import CompetitiveAnalysisTable from './CompetitiveAnalysisTable'
import CompetitionHeader from './CompetitionHeader'
// import { Paper } from '@mui/material'
import CompetitiveGraphConatiner from "./CompetitiveGraphConatiner"
import useGraphs from "../../hooks/useGraphs"

export default function CompetitiveAnalysis({dataset, ticker, sectionId}) {
    const [competitors, setCompetitors] = useState([])
    const tickersList = useMemo(() => [...competitors, ticker], [competitors, ticker])
    const { createCompetitiveGraph, graphsId } = useGraphs({sectionId, dataset, tickers: tickersList})

    const clickUpdateButton = (tickers) => {
        createCompetitiveGraph(dataset, [...tickers, ticker])
        setCompetitors(tickers)
    }

    useEffect(() => {
        // fetch('/api/getCompetitors',{
        //     method: 'post',
        //     headers: {'Content-Type': 'application/json'},
        //     body: JSON.stringify({ sectionId })
        // })
        axios({
            method: 'post',
            url: '/api/getCompetitors',
            data: { sectionId }
        })
        .then(res => res.data).then(res => {
            const tickerIndex = res.indexOf(ticker)
            if (tickerIndex > -1) {
                res.splice(tickerIndex, 1)
            }
            setCompetitors(res) 
        })
        return () => setCompetitors([])
    }, [sectionId, ticker])

    return (
        tickersList && <>
            <div className='graph graph-min'>
                <CompetitionHeader clickUpdateButton={clickUpdateButton} tickersList={competitors} ticker={ticker}/>
                {/* <CompetitiveAnalysisTable tickers={tickersList} sectionId={sectionId}/> */}
            </div>
            <CompetitiveGraphConatiner graphsId={graphsId} dataset={dataset}/> 
        </>
    )
}